import * as React from "react";
import Row from "../../layout/Row";
import CustomField, {CustomFieldType} from "../../../model/customField/CustomField";
import {none, option, Option} from "ts-option";
import EnumInFormDisplay from "../customFields/EnumInFormDisplay";
import BooleanInFormDisplay from "../customFields/BooleanInFormDisplay";
import CustomFieldValue from "../../../model/job/CustomFieldValue";
import * as _ from "underscore";
import StringInFormDisplay from "../customFields/StringInFormDisplay";
import * as moment from 'moment';
import DateInFormDisplay from "../customFields/DateInFormDisplay";
import {PartnerBrandSubsectionTitle} from "./sections/PartnerBrandSectionTitle";

interface ComponentProps {
	/**
	 * Partner Brand custom fields list.
	 */
	customFields: Option<CustomField[]>;
	/**
	 * Partner brand custom fields values
	 */
	customFieldsValues: Option<CustomFieldValue[]>;
	/**
	 * Update custom field values action.
	 * @param {CustomFieldValue[]} updatedCustomFieldsValues
	 */
	updateCustomFieldsValues: (updatedCustomFieldsValues: CustomFieldValue[]) => void;
}

export default class PartnerBrandCustomFieldsValues extends React.Component<ComponentProps> {
	render() {
		return (
			<div className={"c-create-brand"}>
				<PartnerBrandSubsectionTitle title={"Custom fields"}/>
				<Row>
					{this.props.customFields.getOrElse([]).map((field, index) =>
						<React.Fragment key={index}>{this.renderCustomField(field)}</React.Fragment>
					)}
				</Row>
			</div>
		);
	}

	renderCustomField(field: CustomField) {
		switch (field.fieldType) {
			case CustomFieldType.ENUM:
				return <EnumInFormDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					items={field.options}
					label={field.label}
					selectedValue={this.getSelectedCustomFieldValue(field.id)}/>;
			case CustomFieldType.BOOLEAN:
				return <BooleanInFormDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					label={field.label}
					selectedValue={this.getSelectedCustomFieldValue(field.id)}/>;
			case CustomFieldType.STRING:
				return <StringInFormDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					label={field.label}
					value={this.getSelectedCustomFieldValue(field.id)}/>;
			case CustomFieldType.DATE:
				return <DateInFormDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					value={this.getSelectedCustomFieldValue(field.id).map(val => moment(val))}
					label={field.label}/>
		}
	}

	getSelectedCustomFieldValue(id: string): Option<string> {
		const selectedCustomFieldValue = _.find(this.props.customFieldsValues.getOrElse([]), (item) => item.customFieldId === id);
		return selectedCustomFieldValue ? selectedCustomFieldValue.value : none;
	}

	updateCustomFieldValue(customFieldId: string, updatedValue: string) {
		const currentValueIdx = _.findIndex(this.props.customFieldsValues.getOrElse([]),
			(item) => item.customFieldId === customFieldId);
		if (currentValueIdx !== -1 && updatedValue === '') {
			this.removeCustomFieldValue(this.props.customFieldsValues.get[currentValueIdx].customFieldId);
		}
		else if (currentValueIdx !== -1 && updatedValue !== '') {
			this.props.customFieldsValues.get[currentValueIdx] =
				this.props.customFieldsValues.get[currentValueIdx].copy({value: option(updatedValue)});
			this.props.updateCustomFieldsValues(this.props.customFieldsValues.getOrElse([]));
		}
		else if (updatedValue !== '') {
			this.props.customFieldsValues.getOrElse([]).push(
				new CustomFieldValue(none, customFieldId, option(updatedValue)));
			this.props.updateCustomFieldsValues(this.props.customFieldsValues.getOrElse([]));
		}
	}

	removeCustomFieldValue(customFieldId: string) {
		const currentValueIdx = _.findIndex(this.props.customFieldsValues.getOrElse([]),
			(item) => item.customFieldId === customFieldId);
		if (currentValueIdx !== -1) {
			this.props.customFieldsValues.get[currentValueIdx] =
				this.props.customFieldsValues.get[currentValueIdx].copy({value: none});
			this.props.updateCustomFieldsValues(this.props.customFieldsValues.getOrElse([]));
		}
	}
}